//import axios from "axios";
//import API_BASE_URL from "../../../config/apiConfig";
import Data from "../../../../pages/Tools/Apps/NoRecentVisit/FakeRepository/Data.json";

//const API_URL = `${API_BASE_URL}/api/PatientInfo/Patientmap`;

export const getNoRecentVisitMap = () => {
  try {
    // const params = {
    //   memberName,
    //   DOB,
    //   location,
    //   dateOfService,
    //   appointmentType,
    //   didYouHave,
    //   wasPatientReferredout,
    //   didYouGiveTheLabOrder,
    //   comments,
    //   medicalCenter,
    //   staff,
    //   timeStamp,
    //   page,
    //   pageSize
    // };

    // const response = await axios.get(API_URL, {
    //   headers: {
    //     Authorization: `Bearer ${localStorage.getItem("token")}`
    //   },
    //   params
    // });

    const response = Data;

    return response; // Será un PatientMapPageResultDto
  } catch (error) {
    console.error("Error fetching patient map:", error);
    throw error;
  }
};

// {
//   memberName,
//   DOB,
//   location,
//   dateOfService,
//   appointmentType,
//   didYouHave,
//   wasPatientReferredout,
//   didYouGiveTheLabOrder,
//   comments,
//   medicalCenter,
//   staff,
//   timeStamp,
//   page = 1,
//   pageSize = 50
// }
